import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
  cache: false,
};
export default {
  path: "/hotlineMonitor",
  name: "hotlineMonitor",
  meta,
  component: BasicLayout,
  children: [
    {
      path: "/hotlineMonitor/sittingSupervision",
      name: "sittingSupervision",
      meta: {
        ...meta,
        title: "坐席监察",
      },
      component: () => import("@/pages/hotlineMonitor/sittingSupervision/sittingSupervisionPage.vue"),
    },
    {
      path: "/hotlineMonitor/orderMonitorHot",
      name: "orderMonitorHot",
      meta: {
        ...meta,
        title: "工单监察（热线平台）",
      },
      component: () => import("@/pages/hotlineMonitor/orderMonitorHot.vue"),
    },
    {
      path: "/hotlineMonitor/busyTime",
      name: "busyTime",
      meta: {
        ...meta,
        title: "示忙时间统计表",
      },
      component: () => import("@/pages/hotlineMonitor/busyTime.vue"),
    },
    {
      path: "/hotlineMonitor/signInOut",
      name: "signInOut",
      meta: {
        ...meta,
        title: "签入、签出统计表",
      },
      component: () => import("@/pages/hotlineMonitor/signInOut.vue"),
    },
    {
      path: "/hotlineMonitor/rateAndDuration",
      name: "rateAndDuration",
      meta: {
        ...meta,
        title: "接通率及话务时间统计表",
      },
      component: () => import("@/pages/hotlineMonitor/rateAndDuration.vue"),
    },
    {
      path: "/hotlineMonitor/orderGenerationRate",
      name: "orderGenerationRate",
      meta: {
        ...meta,
        title: "工单生成率统计表",
      },
      component: () => import("@/pages/hotlineMonitor/orderGenerationRate.vue"),
    },
    {
      path: "/hotlineMonitor/timeoutOrderDetail",
      name: "timeoutOrderDetail",
      meta: {
        ...meta,
        title: "超时办结工单明细",
      },
      component: () => import("@/pages/hotlineMonitor/timeoutOrderDetail.vue"),
    },
    {
      path: "/hotlineMonitor/handleStatistics",
      name: "handleStatistics",
      meta: {
        ...meta,
        title: "接诉即办 办件统计（计划时间）",
      },
      component: () => import("@/pages/hotlineMonitor/handleStatistics.vue"),
    },
    {
      path: "/hotlineMonitor/sourceStatistics",
      name: "sourceStatistics",
      meta: {
        ...meta,
        title: "工单统计（按来源）",
      },
      component: () => import("@/pages/hotlineMonitor/sourceStatistics.vue"),
    },
    {
      path: "/hotlineMonitor/callAndConnect",
      name: "callAndConnect",
      meta: {
        ...meta,
        title: "话务量、接通率",
      },
      component: () => import("@/pages/hotlineMonitor/callAndConnect.vue"),
    },
    {
      path: "/hotlineMonitor/centralizedStatisticso",
      name: "centralizedStatisticso",
      meta: {
        ...meta,
        title: "工单归口统计",
      },
      component: () => import("@/pages/hotlineMonitor/centralizedStatisticso.vue"),
    },
    {
      path: "/hotlineMonitor/orderMonitor/hotCenter",
      name: "orderMonitorHotCenter",
      meta: {
        ...meta,
        title: "工单监察（热线中心）",
      },
      component: () => import("@/pages/hotlineMonitor/orderMonitor/hotCenter.vue"),
    },
    {
      path: "/hotlineMonitor/orderMonitor/organizeDepartment",
      name: "orderMonitorOrganizeDepartment",
      meta: {
        ...meta,
        title: "工单监察（承办部门）",
      },
      component: () => import("@/pages/hotlineMonitor/orderMonitor/organizeDepartment.vue"),
    },
  ],
};
